import './App.css';
import Countries from './components/Countries/Countries';

// import { useEffect, useState } from 'react';

function App() {
  return (
    <div className="App">
      <Countries></Countries>

      {/* <LoadCountries></LoadCountries>
      <Country></Country> */}
    </div>
  );
}



/* function LoadCountries() {
  const [countries, setCountries] = useState([]);
  useEffect(() => {
    fetch('https://restcountries.com/v3.1/all')
      .then(res => res.json())
      .then(data => setCountries(data));
  }, [])

  return (
    <div>
      <h1>React Rest Countries</h1>
      <h3>Total Countries: {countries.length}</h3>
      {
        countries.map(country => <Country name={country.name.common} capital={country.capital} population={country.population} continent={country.continents} flag={country.flags.png}></Country>)
      }
    </div>
  )
}

function Country(props) {
  return (
    <div style={{ margin: '20px', padding: '20px', border: '2px solid maroon' }}>
      <h2>Name: {props.name}</h2>
      <h3>Capital: {props.capital}</h3>
      <h4>Population: {props.population}</h4>
      <h5>Continent: {props.continent}</h5>
      <img src={props.flag} alt="Flag" />
    </div>
  )
} */

export default App;
